import react, {useEffect, useState} from "react";
import { useParams, Link } from "react-router-dom";
import useToken from "../useToken";


export default function Contacts(){
    const token = useToken();
    let params = useParams();
    let account_id='';
    if (params.id!=undefined)
        account_id = params.id;

    

    const[contacts, setContacts] = useState([]);


    useEffect(()=>{
        let URL='';
        if (account_id=='')
            URL = process.env.NODE_ENV === 'development' ? `${process.env.REACT_APP_API_URL_DEV_MODE}api/contacts/`: `${process.env.REACT_APP_API_URL_PROD_MODE}api/contacts/`;
        else
            URL = process.env.NODE_ENV === 'development' ? `${process.env.REACT_APP_API_URL_DEV_MODE}api/contacts/${account_id}/`: `${process.env.REACT_APP_API_URL_PROD_MODE}api/contacts/${account_id}/`;
        
        
        console.log(URL)
        fetch(URL, {headers: {"Authorization" :  `Token ${token}`}})
            .then((res) => res.json())
            .then((data)=>{
                setContacts(oldData=>[...contacts, ...data]);

            })
            .catch(error=> console.log(error))

    }, []);

    // Now return contacts JSX
    return(
            <div className="account-card-container">
                {contacts.map(contactObj =>
                    <div className="accountCard">
                        
                            <div className="cardHeader"><Link to={`/interaction/${contactObj.id}/`}>{contactObj.salutation}  {contactObj.first_name}  {contactObj.last_name}</Link></div>
                            <div className="cardContent">
                                
                                <div> <b>Email </b>{contactObj.email} </div>
                            </div>
                            <div className="cardFooter"> <Link to={`/interaction/${contactObj.id}/`}>Log Interaction</Link></div>
                        
                    </div>
                )}
            </div>
    );

    
}